import { Spin } from 'antd';
import React, { lazy, useContext, useEffect, useState } from 'react';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation
} from 'react-router-dom';
import AdminConfig from './admin/AdminConfig';
import Core from './admin/Core';
import Organizacion from './admin/Organizacion';
import AdminAseguradoraForm from './admin/aseguradora/AdminAseguradoraForm';
import AdminAseguradoraLanding from './admin/aseguradora/AdminAseguradoraLanding';
import AdminAseguradoraPlanes from './admin/aseguradora/AdminAseguradoraPlanes';
import AutorizacionAseguradora from './admin/aseguradora/AutorizacionAseguradora';
import AutorizacionAseguradoraEmpresa from './admin/aseguradora/AutorizacionAseguradoraEmpresa';
import ConfiguracionCodigoAgente from './admin/aseguradora/ConfiguracionCodigoAgente';
import AutorizacionConfig from './admin/autorizacion/AutorizacionConfig';
import AutorizacionTipoValidaciones from './admin/autorizacion/AutorizacionTipoValidaciones';
import Verificadores from './admin/autorizacion/Verificadores';
import AdminVehiculo from './admin/core/admin-vehiculo/AdminVehiculo';
import AnioSubmodelos from './admin/core/admin-vehiculo/AnioSubmodelos';
import Marcas from './admin/core/admin-vehiculo/Marcas';
import Modelos from './admin/core/admin-vehiculo/Modelos';
import Submodelos from './admin/core/admin-vehiculo/Submodelos';
import AutorizacionEmpresa from './admin/empresa/AutorizacionEmpresa';
import CanalEmpresa from './admin/empresa/CanalEmpresa';
import EnlaceEmpresa from './admin/empresa/EnlaceEmpresa';
import CanalEnlace from './admin/empresa/canal/CanalEnlace';
import UsuarioEnlace from './admin/empresa/canal/UsuarioEnlace';
import Unathorized from './components/401';
import NotFound from './components/404';
import Dashboard from './components/Dashboard';
import FirmaView from './components/FirmaView';
import Perfil from './components/Perfil';
import PlanesAsignacion from './components/PlanesAsignacion';
import SolicitudEdit from './components/SolicitudEdit';
import SolicitudList from './components/SolicitudList';
import SolicitudView from './components/SolicitudView';
import TerminosCondiciones from './components/TerminosCondiciones';
import { TIPOS_PRODUCTOS, USER_STATES } from './constants';
import EmpresaContext from './context/empresa-context';
import UserContext from './context/user-context';
import PreSolicitudForm from './forms/PreSolicitudForm';
import RegenerarToken from './forms/RegenerarToken';
import GenerarPolizaCartaVerde from './forms/cartaVerde/GenerarPolizaCartaVerde';
import PreSolicitudCartaVerde from './forms/cartaVerde/PreSolicitudCartaVerde';
import CotizacionHogarForm from './forms/hogar/CotizacionHogarForm';
import CotizacionPersonalForm from './forms/personal/CotizacionPersonalForm';
import CotizacionVehiculoForm from './forms/vehiculo/CotizacionVehiculoForm';
import CotizacionViajeForm from './forms/viaje/CotizacionViajeForm';
import Aseguradora from './modelos/admins/Aseguradora';
import AseguradoraDetenerProceso from './modelos/admins/AseguradoraDetenerProceso';
import AseguradoraEmpresaProducto from './modelos/admins/AseguradoraEmpresaProducto';
import AseguradoraEmpresaProductoVigencia from './modelos/admins/AseguradoraEmpresaProductoVigencia';
import AseguradoraEmpresaUsuario from './modelos/admins/AseguradoraEmpresaUsuario';
import AseguradoraProducto from './modelos/admins/AseguradoraProducto';
import AseguradoraProductoCobertura from './modelos/admins/AseguradoraProductoCobertura';
import AseguradoraProductoCoberturaForm from './modelos/admins/AseguradoraProductoCoberturaForm';
import AseguradoraProductoVigencia from './modelos/admins/AseguradoraProductoVigencia';
import Empresa from './modelos/admins/Empresa';
import AutorizacionList from './modelos/autorizacion/AutorizacionList';
import AutorizacionVerify from './modelos/autorizacion/AutorizacionVerify';
import ComisionList from './modelos/comisiones/ComisionList';
import CotizacionAMedida from './modelos/cotizaciones/CotizacionAMedida';
import CotizacionList from './modelos/cotizaciones/CotizacionList';
import CotizacionMasivaList from './modelos/cotizaciones/CotizacionMasivaList';
import CrearCotizacion from './modelos/cotizaciones/CrearCotizacion';
import CrearCotizacionMasiva from './modelos/cotizaciones/CrearCotizacionMasiva';
import LandingCotizacion from './modelos/cotizaciones/LandingCotizacion';
import InspeccionForm from './modelos/inspecciones/InspeccionForm';
import InspeccionList from './modelos/inspecciones/InspeccionList';
import Ampliacion from './modelos/inspecciones/inspector/Ampliacion';
import InspeccionEdit from './modelos/inspecciones/inspector/InspeccionEdit';
import AmpliacionSteps from './modelos/inspecciones/solicitante/ampliacion/AmpliacionSteps';
import JobForm from './modelos/jobs/JobForm';
import JobList from './modelos/jobs/JobList';
import JobView from './modelos/jobs/JobView';
import PolizaAnulacion from './modelos/polizas/PolizaAnulacion';
import PolizaEstadoView from './modelos/polizas/PolizaEstadoView';
import PolizaForm from './modelos/polizas/PolizaForm';
import PolizaList from './modelos/polizas/PolizaList';
import PolizaMasivaForm from './modelos/polizas/PolizaMasivaForm';
import PolizaView from './modelos/polizas/PolizaView';
import PromocionForm from './modelos/promociones/PromocionForm';
import PromocionList from './modelos/promociones/PromocionList';
import PromocionView from './modelos/promociones/PromocionView';
import ProveedorForm from './modelos/proveedores/ProveedorForm';
import ProveedorList from './modelos/proveedores/ProveedorList';
import ProveedorView from './modelos/proveedores/ProveedorView';
import FirmaDenuncia from './modelos/siniestros/FirmaDenuncia';
import Landing from './modelos/siniestros/Landing';
import SiniestroForm from './modelos/siniestros/SiniestroForm';
import SiniestroFormLanding from './modelos/siniestros/SiniestroFormLanding';
import SiniestroList from './modelos/siniestros/SiniestroList';
import SiniestroView from './modelos/siniestros/SiniestroView';
import PeritajeForm from './modelos/siniestros/peritaje/PeritajeForm';
import SucursalForm from './modelos/sucursales/SucursalForm';
import SucursalList from './modelos/sucursales/SucursalList';
import SucursalView from './modelos/sucursales/SucursalView';
import CatastroFirma from './modelos/usuarios/CatastroFirma';
import UsuarioForm from './modelos/usuarios/UsuarioForm';
import UsuarioList from './modelos/usuarios/UsuarioList';
import UsuarioView from './modelos/usuarios/UsuarioView';
import { rutasPorGrupo } from './utils';

const LandingSegu = lazy(() => import('./modelos/cotizaciones/LandingSegu'));

const Inicio = (props) => {
  const { user, userState } = useContext(UserContext);
  const { empresa } = useContext(EmpresaContext);

  const noEstaLogueado =
    !user &&
    (userState === USER_STATES.loggingEnd ||
      userState === USER_STATES.notLogged);

  const tieneLanding = empresa?.tiene_landing;
  const tieneLandingSegu = empresa?.tiene_landingsegu;

  if (noEstaLogueado && tieneLanding && tieneLandingSegu) {
    return <LandingSegu {...props} />;
  }

  if (noEstaLogueado && tieneLanding) {
    return <LandingCotizacion {...props} />;
  }
  return <Spin delay={500} style={{ paddingTop: 196 }} />;
};

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { user, userState } = useContext(UserContext);
  const [puedeIngresar, setPuedeIngresar] = useState();
  const history = useHistory();

  useEffect(() => {
    if (
      user &&
      rest.tieneGestionSistema !== undefined &&
      rest.tieneGestionUsuarios !== undefined
    ) {
      const gruposDelUsuario = user['cognito:groups'];
      const rutasDelUsuario = gruposDelUsuario
        ? rutasPorGrupo[gruposDelUsuario[0]]
        : [];
      const puede =
        user &&
        gruposDelUsuario &&
        rutasDelUsuario.filter((item) => rest.path.startsWith(item)).length > 0;
      if (
        rest.path.startsWith('/usuarios') &&
        rest.tieneGestionUsuarios === true
      ) {
        setPuedeIngresar(puede);
      } else if (
        !rest.path.startsWith('/usuarios') &&
        rest.tieneGestionSistema === true
      ) {
        setPuedeIngresar(puede);
      } else if (gruposDelUsuario[0] === 'CLIENTE') {
        setPuedeIngresar(puede);
      } else {
        setPuedeIngresar(false);
      }
    } else if (
      userState === USER_STATES.notLogged ||
      userState === USER_STATES.loggingEnd
    ) {
      setPuedeIngresar(false);
    }
  }, [
    rest.path,
    rest.tieneGestionSistema,
    rest.tieneGestionUsuarios,
    user,
    userState
  ]);
  return (
    <>
      {userState === USER_STATES.notLogged ||
      (userState === USER_STATES.loggingEnd &&
        !puedeIngresar &&
        rest.tieneGestionUsuarios === undefined &&
        rest.tieneGestionSistema === undefined) ? (
        history.push('/login')
      ) : (
        // <Route {...rest} component={Unathorized} />
        <>
          {userState === USER_STATES.loggingStart ||
            (rest.tieneGestionUsuarios === undefined &&
              rest.tieneGestionSistema === undefined && (
                <div style={{ paddingTop: 196 }}>
                  <Spin delay={500} />
                </div>
              ))}
          {userState === USER_STATES.loggingEnd &&
            puedeIngresar === true &&
            rest.tieneGestionUsuarios !== undefined &&
            rest.tieneGestionSistema !== undefined && (
              <Route {...rest} render={(props) => <Component {...props} />} />
            )}
          {userState === USER_STATES.loggingEnd &&
            puedeIngresar === false &&
            rest.tieneGestionUsuarios !== undefined &&
            rest.tieneGestionSistema !== undefined && (
              <Route {...rest} component={Dashboard} />
              // <Route {...rest} component={Unathorized} />
            )}
        </>
      )}
    </>
  );
};

const Routes = () => {
  const { pathname } = useLocation();
  const [tieneProducto, setTieneProducto] = useState();
  const { productos } = useContext(EmpresaContext);
  const { user } = useContext(UserContext);
  const [params, setParams] = useState({
    tieneGestionUsuarios: false,
    tieneGestionSistema: false
  });
  const { empresa } = useContext(EmpresaContext);

  const tieneLandingSegu = empresa?.tiene_landingsegu;

  const renderProducto = (Component, props) => (
    <Component {...props} key={props.location.key} />
  );
  useEffect(() => {
    if (productos && productos.length > 0) {
      if (pathname !== '/') {
        const linkTipoProducto = pathname.split('/')[1];
        const tipoProducto = TIPOS_PRODUCTOS.find(
          (item) => item.link === linkTipoProducto
        );
        if (tipoProducto) {
          const productoEncontrado = productos.find(
            ({ codigo }) => codigo === tipoProducto.codigo
          );
          if (productoEncontrado) {
            setTieneProducto(true);
          } else {
            setTieneProducto(false);
          }
        } else {
          setTieneProducto(false);
        }
      }
    }
  }, [pathname, productos]);

  useEffect(() => {
    if (user) {
      if (user.usuarioSegu.gestion_usuarios) {
        setParams((p) => ({ ...p, tieneGestionUsuarios: true }));
      } else {
        setParams((p) => ({ ...p, tieneGestionUsuarios: false }));
      }
      if (user.usuarioSegu.gestion_sistema) {
        setParams((p) => ({ ...p, tieneGestionSistema: true }));
      } else {
        setParams((p) => ({ ...p, tieneGestionSistema: false }));
      }
    }
  }, [user]);
  return (
    <Switch>
      <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
      {/* <Route exact path="/" component={Inicio} /> */}
      <Route exact path="/" component={Inicio} />
      <ProtectedRoute {...params} exact path="/panel" component={Dashboard} />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-aseguradora"
        component={Aseguradora}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-aseguradoraempresaproducto/:id"
        component={AseguradoraEmpresaProducto}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-aseguradoraempresausuario/:id"
        component={AseguradoraEmpresaUsuario}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-aseguradora-parametros/:id"
        component={AdminAseguradoraForm}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-aseguradora-productos/:id"
        component={AseguradoraProducto}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-aseguradora-planes/:id"
        component={AdminAseguradoraPlanes}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-aseguradora-asignacion/:id"
        component={PlanesAsignacion}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-aseguradora-codigoagente/:id"
        component={ConfiguracionCodigoAgente}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-aseguradora-landing/:id"
        component={AdminAseguradoraLanding}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-aseguradora-detener/:id"
        component={AseguradoraDetenerProceso}
      />
      <Route exact path="/perfil" component={Perfil} />
      <Route exact path="/perfil/firma" component={CatastroFirma} />
      <ProtectedRoute
        {...params}
        exact
        path="/polizas"
        component={PolizaList}
      />
      <Route exact path="/polizas/estado/:id" component={PolizaEstadoView} />
      <Route exact path="/polizas(-mail|-sms)?/:id" component={PolizaView} />
      <Route
        exact
        path="/polizas/anulacion-poliza/:token/"
        component={PolizaAnulacion}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/solicitudes"
        component={SolicitudList}
      />
      <Route exact path="/solicitudes/:id" component={SolicitudView} />
      <Route exact path="/solicitud/edit/:id" component={SolicitudEdit} />
      <Route exact path="/solicitudes-consulta/:id" component={SolicitudView} />
      <ProtectedRoute
        {...params}
        exact
        path="/cotizaciones"
        component={CotizacionList}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/cotizacionesmasivas"
        component={CotizacionMasivaList}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/usuarios"
        component={UsuarioList}
        {...params}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/usuarios/form/:id?"
        component={UsuarioForm}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/usuarios/view/:id?"
        component={UsuarioView}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/usuarios/view/edit/:id?"
        component={UsuarioForm}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/sucursales"
        component={SucursalList}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/sucursales/form/:id?"
        component={SucursalForm}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/sucursales/view/:id?"
        component={SucursalView}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/sucursales/view/edit/:id?"
        component={SucursalForm}
      />
      <Route exact path="/401" component={Unathorized} />
      {tieneProducto && !tieneLandingSegu && (
        <>
          <Route
            exact
            path="/vehiculo"
            render={(props) => renderProducto(CotizacionVehiculoForm, props)}
          />
          <Route
            exact
            path="/personal"
            render={(props) => renderProducto(CotizacionPersonalForm, props)}
          />
          <Route
            exact
            path="/vida"
            render={(props) => renderProducto(CotizacionPersonalForm, props)}
          />
          <Route
            exact
            path="/hogar"
            render={(props) => renderProducto(CotizacionHogarForm, props)}
          />
          <Route
            exact
            path="/comercio"
            render={(props) => renderProducto(CotizacionHogarForm, props)}
          />
          <Route
            exact
            path="/finanzas"
            render={(props) => renderProducto(CotizacionPersonalForm, props)}
          />
          <Route
            exact
            path="/viaje"
            render={(props) => renderProducto(CotizacionViajeForm, props)}
          />
          {/* Rutas para el ingreso de cotizaciones del vehiculo desde el envio masivo */}
          <Route
            exact
            path="/vehiculo/:tokenPersona"
            render={(props) => renderProducto(CotizacionVehiculoForm, props)}
          />
          <Route
            exact
            path="/comercio/:tokenPersona"
            render={(props) => renderProducto(CotizacionHogarForm, props)}
          />
        </>
      )}
      {tieneProducto && tieneLandingSegu && (
        <>
          <Route
            exact
            path="/vehiculo"
            render={(props) => renderProducto(LandingSegu, props)}
          />
        </>
      )}
      <Route
        exact
        path="/solicitar/:token/:tipo?"
        component={PreSolicitudForm}
      />
      <Route
        exact
        path="/solicitar-mail/:token/:tipo?"
        component={PreSolicitudForm}
      />
      <Route
        exact
        path="/solicitar-sms/:token/:tipo?"
        component={PreSolicitudForm}
      />
      {/* Flujo de solicitud para carta verde */}
      <Route
        exact
        path="/solicitar-cv/:token"
        component={PreSolicitudCartaVerde}
      />
      <Route
        exact
        path="/solicitar-cv-mail/:token"
        component={PreSolicitudCartaVerde}
      />
      <Route exact path="/regenerar-token" component={RegenerarToken} />
      <Route exact path="/firmar/:token" component={FirmaView} />
      <Route exact path="/firmar-publico/:token" component={FirmaView} />
      <Route exact path="/firmar-sms/:token" component={FirmaView} />
      <Route
        exact
        path="/generar-cv/:token"
        component={GenerarPolizaCartaVerde}
      />
      <Route
        exact
        path="/generar-cv-publico/:token"
        component={GenerarPolizaCartaVerde}
      />
      <Route
        exact
        path="/inspecciones/edit/:token"
        component={InspeccionEdit}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/inspecciones"
        component={InspeccionList}
      />
      <Route
        exact
        path="/inspecciones/form/:token?"
        component={InspeccionForm}
      />
      <Route
        exact
        path="/inspecciones-publico/form/:token?"
        component={InspeccionForm}
      />
      <Route exact path="/inspecciones/ampliacion/:id" component={Ampliacion} />
      <Route
        exact
        path="/inspecciones/ampliacion/cliente/:token"
        component={AmpliacionSteps}
      />
      <Route exact path="/promociones" component={PromocionList} />
      <ProtectedRoute
        {...params}
        exact
        path="/promociones/view/:id?"
        component={PromocionView}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/promociones/form/:id?"
        component={PromocionForm}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/promociones/view/edit/:id?"
        component={PromocionForm}
      />
      <Route exact path="/proveedores" component={ProveedorList} />
      <ProtectedRoute
        {...params}
        exact
        path="/proveedores/form/:id?"
        component={ProveedorForm}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/proveedores/view/:id?"
        component={ProveedorView}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/proveedores/view/edit/:id?"
        component={ProveedorForm}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/denuncia-siniestro"
        component={Landing}
      />
      <Route
        exact
        path="/denuncia-siniestro-landing/:token"
        component={SiniestroFormLanding}
      />
      <Route
        exact
        path="/denuncia-siniestro/:token"
        component={SiniestroForm}
      />
      <Route exact path="/siniestro-sms/:token" component={SiniestroForm} />

      <Route exact path="/firmar-denuncia/:token" component={FirmaDenuncia} />
      <ProtectedRoute
        {...params}
        exact
        path="/siniestros"
        component={SiniestroList}
      />
      <Route exact path="/siniestros/:token" component={SiniestroView} />
      <Route exact path="/siniestros/form/:token" component={PeritajeForm} />
      <Route
        exact
        path="/siniestros/form/:token/desktop"
        component={PeritajeForm}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/crearcotizacion"
        component={CrearCotizacion}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/crearcotizacionmasiva"
        component={CrearCotizacionMasiva}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/cotizacionamedida"
        component={CotizacionAMedida}
      />
      <Route
        exact
        path="/terminos-condiciones"
        component={TerminosCondiciones}
      />
      <Route exact path="/poliza/subir/:token" component={PolizaForm} />
      <Route exact path="/poliza/masiva" component={PolizaMasivaForm} />
      {/* <ProtectedRoute {...params} exact path="/cobranzas" component={CobranzaList} /> */}
      <ProtectedRoute
        {...params}
        exact
        path="/comisiones"
        component={ComisionList}
      />
      <ProtectedRoute {...params} exact path="/jobs" component={JobList} />
      <ProtectedRoute
        {...params}
        exact
        path="/jobs/form/:id?"
        component={JobForm}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/jobs/view/:id?"
        component={JobView}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/jobs/view/edit/:id?"
        component={JobForm}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-empresa"
        component={Empresa}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/admin-config"
        component={AdminConfig}
      />
      <Route
        exact
        path="/vigencia/config/:id"
        component={AseguradoraEmpresaProductoVigencia}
      />
      <ProtectedRoute
        {...params}
        path="/aseguradoraproducto/vigencia/config/:id"
        component={AseguradoraProductoVigencia}
      />
      <ProtectedRoute
        {...params}
        path="/aseguradoraproducto/cobertura-form/:id/:idCobertura?"
        component={AseguradoraProductoCoberturaForm}
      />
      <ProtectedRoute
        {...params}
        path="/aseguradoraproducto/cobertura/:id"
        component={AseguradoraProductoCobertura}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/autorizaciones"
        component={AutorizacionList}
      />
      <Route
        exact
        path="/autorizaciones/:token"
        component={AutorizacionVerify}
      />
      <Route
        exact
        path="/autorizaciones/:token/view"
        component={AutorizacionVerify}
      />
      <Route
        exact
        path="/autorizacion-config-aseguradora/:id"
        component={AutorizacionAseguradora}
      />
      <Route
        exact
        path="/autorizacion-config-aseguradora-empresa/:id"
        component={AutorizacionAseguradoraEmpresa}
      />
      <ProtectedRoute
        exact
        {...params}
        path="/autorizacion-config-empresa/:id"
        component={AutorizacionEmpresa}
      />
      <ProtectedRoute
        exact
        {...params}
        path="/canal-config-empresa/:id"
        component={CanalEmpresa}
      />
      {empresa?.codigo === 'segutotal' && (
        <ProtectedRoute
          exact
          {...params}
          path="/enlace-config-empresa/:id"
          component={EnlaceEmpresa}
        />
      )}
      <ProtectedRoute
        exact
        {...params}
        path="/canal-config-empresa/:id"
        component={CanalEmpresa}
      />
      <ProtectedRoute
        exact
        {...params}
        path="/canal-config-empresa/enlace-usuarios/:idEmpresa/:idCanal/:idEnlace"
        component={UsuarioEnlace}
      />
      <ProtectedRoute
        exact
        {...params}
        path="/canal-config-empresa/enlace-canales/:idEmpresa/:idCanal"
        component={CanalEnlace}
      />
      <Route exact path="/verificadores/:tipo/:id" component={Verificadores} />
      <Route
        exact
        path="/autorizacion-configuracion/:tipo/:id"
        component={AutorizacionTipoValidaciones}
      />
      <Route
        exact
        path="/autorizacion-configuracion/:tipo/:id/:tipoValidacion"
        component={AutorizacionConfig}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/organizacion"
        component={Organizacion}
      />
      <ProtectedRoute {...params} exact path="/core" component={Core} />
      <ProtectedRoute
        {...params}
        exact
        path="/core/admin-vehiculo"
        component={AdminVehiculo}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/core/admin-vehiculo/marcas"
        component={Marcas}
      />
      <ProtectedRoute
        {...params}
        exact
        path="/core/admin-vehiculo/modelos"
        component={Modelos}
      />

      <ProtectedRoute
        {...params}
        exact
        path="/core/admin-vehiculo/submodelos"
        component={Submodelos}
      />

      <ProtectedRoute
        {...params}
        exact
        path="/core/admin-vehiculo/anios"
        component={AnioSubmodelos}
      />

      {tieneProducto === false ? <NotFound /> : null}
    </Switch>
  );
};

export default Routes;
